import { gql, useQuery } from '@apollo/client';
import { ListUnifiedFieldsInput, Query } from 'generated/graphql';
import { useGetUser } from 'v2/core/services/user';

export const LIST_UNIFIED_FIELDS_GQL = gql`
  query listUnifiedFields(
    $tenantID: ID!
    $query: String
    $key: String
    $limitValues: Int
  ) {
    listUnifiedFields(
      request: {
        tenantID: $tenantID
        query: $query
        key: $key
        limitValues: $limitValues
      }
    ) {
      fields {
        eqlField {
          detail {
            metadata {
              references {
                displayName
                iconURL
                key
                source
              }
              source
            }
            reference {
              creatorName
              referenceID
              referenceType
              creatorID
            }
          }
          displayName
          field
          iconURL
          isMultiValue
          objectType
          valueType
        }
        values {
          displayName
          iconURL
          value
        }
      }
    }
  }
`;

export const LIST_UNIFIED_FIELDS_GQL_WITHOUT_VALUES = gql`
  query listUnifiedFieldsCompact($tenantID: ID!, $query: String) {
    listUnifiedFields(request: { tenantID: $tenantID, query: $query }) {
      fields {
        eqlField {
          detail {
            metadata {
              references {
                displayName
                iconURL
                key
                source
              }
              source
            }
          }
          displayName
          field
          iconURL
          isMultiValue
          objectType
          valueType
        }
      }
    }
  }
`;

interface useFetchEQLReferencesProps {
  searchValue?: string;
  shouldFetchValues?: boolean;
}

export const useFetchUnifiedFields = ({
  searchValue,
  shouldFetchValues = true,
}: useFetchEQLReferencesProps = {}) => {
  const {
    tenant: { id: tenantID },
  } = useGetUser();

  const { data, loading } = useQuery<Query, ListUnifiedFieldsInput>(
    shouldFetchValues
      ? LIST_UNIFIED_FIELDS_GQL
      : LIST_UNIFIED_FIELDS_GQL_WITHOUT_VALUES,
    {
      variables: {
        tenantID,
        query: searchValue || undefined,
      },
      fetchPolicy: 'cache-and-network',
    },
  );

  return {
    unifiedFields: data?.listUnifiedFields?.fields,
    loading,
  };
};
